const getWebviewApiState = state => state?.webviewApi
// eslint-disable-next-line import/prefer-default-export
export const getArticleUrl = state => getWebviewApiState(state)?.articleUrl
